/**
 * @desc getAbnormal
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/getAbnormal`, {
      method: "POST",

      ...options,
    }),
  );
}
